<template>
    <div>
      <Layout/>
      <Footer/>
    </div>
</template>
<script>
import Layout from '../components/Layout.vue'
import Footer from '../components/Footer.vue'
export default {
  inject:['reload'],
  components : {
    Layout, Footer
  }
}
</script>